<template>
  <div class="inner-content">
    <template v-if="isInterdict">
      <Interdict tip="敬请期待！" hook="vh" />
    </template>
    <template v-else>
      <div class="center">
        <div class="wrap" :style="{ transform: `scale(${scale * 0.95})` }">
          <div class="wawa">
            <div class="btn gotoGift" @click="gotoGift">
              <div class="label-box">
                <span class="label-shadow">前往送礼</span>
                <span class="label-text">前往送礼</span>
              </div>
            </div>
          </div>
          <div class="bg"></div>
          <div class="center-box">
            <div v-show="loginTasks" v-for="(item, index) in loginTasks" :key="index" class="center-item">
              <div class="bg">
                <div class="rewards" @click="handleDedicate(item, 'rewards')">
                  <div class="num">{{ getNum(index) }}</div>
                  <div class="stage" :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }"></div>
                  <div class="describe">
                    <div class="quantities">
                      <div class="label-box">
                        <span class="label-shadow">{{ item.desc }}x {{ item.coins }}</span>
                        <span class="label-text">{{ item.desc }}x {{ item.coins }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.status == 0" class="mask"></div>
                  <div class="status" :class="getPickupStatus(item.status)"></div>
                </div>
                <div v-show="sendTasks" class="accrue" @click="handleDedicate(sendTasks[index], 'accrue')">
                  <div class="num">{{ getNum(index) }}</div>
                  <div class="stage-accrue" :style="{ backgroundImage: 'url(' + sendTasks[index].imgUrl + ')' }"></div>
                  <div class="describe">
                    <div class="quantities">
                      <div class="label-box">
                        <span class="label-shadow">{{ sendTasks[index].desc }}x{{ sendTasks[index].coins }}</span>
                        <span class="label-text">{{ sendTasks[index].desc }}x{{ sendTasks[index].coins }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="sendTasks[index].status == 0" class="mask"></div>
                  <div class="status" :class="getPickupStatus(sendTasks[index].status)"></div>
                </div>
                <div class="stage-describe" :class="{ active: sendTasks[index].status !== 0 }">
                  <div class="stage-text">
                    <div class="label-box">
                      <span class="label-shadow">{{ sendTasks[index].title }}</span>
                      <span class="label-text">{{ sendTasks[index].title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="progress">
            <div class="white">
              <div class="dian">
                <div class="dian-center" v-for="n in 8" :key="n">
                  <div class="dian-white"></div>
                </div>
              </div>
            </div>
            <div class="yellow" :style="{ width: getWidth(isNumber) }"></div>
            <div class="gut">
              <div v-show="isNumber" class="element" v-for="(item, index) in isNumber" :key="index">
                <div class="chang"></div>
              </div>
            </div>
          </div>
          <div class="mission-progress">
            <div class="label-box progress-text">
              <span class="label-shadow">累计给任意战队赠送礼物：</span>
              <span class="label-text">累计给任意战队赠送礼物：</span>
            </div>
            <div class="label-box progress-num">
              <span class="label-shadow">{{ personsRedu }}/30000</span>
              <span class="label-text">{{ personsRedu }}/30000</span>
            </div>
          </div>
        </div>

      </div>
    </template>

    <Prompt ref="prompt"></Prompt>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as api from '@/service/index'
import Prompt from '@/components/prompt'
import Interdict from '@/components/interdict'

export default {
  name: 'Dedicate',
  components: {
    Prompt,
    Interdict
  },
  data() {
    return {
      // 登录奖励
      loginTasks: [],
      // 贡献奖励
      sendTasks: [],
      numberOfElements: 8,
      inRequest: false,
      isNumber: 0,
      personsRedu: 0,
      // timeImg: [
      //   'https://website.xdcdn.net/poster/355916/sausage-match/FMOATHfR.png',
      //   'https://website.xdcdn.net/poster/355916/sausage-match/FMOCp6WJ.png',
      //   'https://website.xdcdn.net/poster/355916/sausage-match/FMOE1YK1.png',
      //   'https://website.xdcdn.net/poster/355916/sausage-match/FMOEGLrQ.png',
      //   'https://website.xdcdn.net/poster/355916/sausage-match/FMOFaIUM.png',
      //   'https://website.xdcdn.net/poster/355916/sausage-match/FMOFkWpf.png',
      //   'https://website.xdcdn.net/poster/355916/sausage-match/FMOFkELW.png',
      //   'https://website.xdcdn.net/poster/355916/sausage-match/FMOFkx4Y.png'
      // ]
    };
  },
  computed: {
    ...mapState(['amount', 'token', 'isInterdict', 'scale']),
    elements() {
      return Array.from({ length: this.numberOfElements }, (_, i) => `Element ${i + 1}`);
    },
  },
  created() {
    // 不显示送礼模块时，拦截不必要的请求
    if(!this.isInterdict) {
      this.fetchActivityList();
      this.reduPersonalRanking()
    }
  },
  methods: {
    ...mapActions(["reqRedDotState"]),
    getNum(index) {
      return index < 10 ? '0' + (index + 1) : index + 1
    },
    getClass(status) {
      return status === 0 ? 'zhezhao' : '';
    },
    getDedicateClass(status) {
      return status === 0 ? 'accruezhezhao' : '';
    },
    getPickupStatus(activeStatus) {
      switch (activeStatus) {
        // 状态，0未完成 1已完成 2已领取
        case 0: return "unlocked";
        case 1: return "locked";
        case 2: return "received";
        default:
          break;
      }
    },
    // 统计已领取的数量
    getCount(sendTasks) {
      this.isNumber = 0
      for (let index = 0; index < sendTasks.length; index++) {
        const element = sendTasks[index];
        if (element.status == 1 || element.status == 2) {
          this.isNumber += 1
        }
      }
    },
    getWidth(isNumber) {
      if (isNumber === 1) {
        return `${100 / 8 * (isNumber / 2)}%`;
      } else if (isNumber === 8) {
        return `${100 / 8 * isNumber}%`;
      } else {
        return `${100 / 8 * isNumber - (100 / 16)}%`;
      }
    },
    async fetchActivityList() {
      if (!this.token) return;
      try {
        const res = await api.getActivityList({ token: this.token, taskType: 2 })
        if (res.status === 200) {
          const { loginTasks, sendTasks } = res.data
          this.loginTasks = loginTasks;
          this.sendTasks = sendTasks
          this.getCount(this.sendTasks)
        }
      } catch (err) {
        console.log(err)
      }
    },
    formatDay(time) {
      // const isoDateString = time.replace(" ", "T");
      let dateObj = new Date(time);
      let month = dateObj.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = dateObj.getDate();
      day = day < 10 ? "0" + day : day;
      return `${month}月${day}日`;
    },

    async handleDedicate(value, type) {
      // console.log(value)
      if (!this.inRequest) {
        this.inRequest = true
        if (value.status == '0') {
          this.$refs.prompt.setMsg('未完成,请再接再厉~');
        } else if (value.status == '1') {
          let data = {
            taskId: value.id
          }
          if (!this.token) return;
          try {
            let response = await api.getActivityReward(this.token, data)
            if (response.status == 200 && response.data === true) {
              const tapdbTetx = type == 'rewards' ? "登录奖励" : "贡献奖励"
              this.fetchActivityList()
              // 红点状态

              this.reqRedDotState()
              const now = await api.reqcurrentTime()
              if (value.isSend) {
                if (!this.token) return;
                await api.reqGiftList({ token: this.token, force: true })
              }
              this.$refs.prompt.setMsg('领取成功～')

              if (now.status == 200) {
                const countdown = this.formatDay(now.data)
                if (typeof tapdb == 'undefined') return;
                // 领取任务奖励
                tapdb.trackEvent(tapdbTetx, {
                  '#mission_unique_id': value.id + "+" + countdown,
                  // 道具数量
                  '#item_gain': value.coins,
                  // 道具id
                  '#prop_id': value.id,
                  // 获得道具原因
                  '#via_type': "累计人气贡献"
                });
              }
            }
          } catch (err) {
            console.log(err)
          }
        } else {
          this.$refs.prompt.setMsg('已领取~');
        }
      }
      this.inRequest = false
    },
    // 获取个人送热度
    async reduPersonalRanking() {
      if (!this.token) return;
      try {
        let { status, data } = await api.getPersonalRanking(this.token)
        if (status === 200) {
          this.personsRedu = data.personal?.popularity
        }
      } catch (err) {
        console.log(err)
      }
    },
    gotoGift() {
      this.$router.push({
        name: 'Live',
        query: {
          is_send: true
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/store/dedicate.scss";
</style>
